import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Zap, X } from 'lucide-react';
const TOTAL_SECONDS = 40 * 60;
export function FlashBanner() {
  const [secondsLeft, setSecondsLeft] = useState(TOTAL_SECONDS);
  const [visible, setVisible] = useState(true);
  useEffect(() => {
    if (secondsLeft <= 0 || !visible) return;
    const timer = setInterval(() => {
      setSecondsLeft(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [visible, secondsLeft]);
  const minutes = Math.floor(secondsLeft / 60);
  const seconds = secondsLeft % 60;
  const pad = (n: number) => n.toString().padStart(2, '0');
  const expired = secondsLeft <= 0;
  return <AnimatePresence data-id="element-108">
      {visible && <motion.div initial={{
      height: 0,
      opacity: 0
    }} animate={{
      height: 'auto',
      opacity: 1
    }} exit={{
      height: 0,
      opacity: 0
    }} transition={{
      duration: 0.3
    }} className="relative z-50 bg-[#14b8a6] text-black overflow-hidden w-full" data-id="element-109">
          <div className="flex items-center justify-center gap-2 px-3 py-1.5 text-xs font-bold" data-id="element-110">
            <Zap size={12} fill="currentColor" className="shrink-0" data-id="element-111" />

            {expired ? <span data-id="element-112">¡La oferta ha expirado!</span> : <>
                <span className="hidden sm:inline" data-id="element-113">⚡ OFERTA FLASH —</span>
                <span className="sm:hidden" data-id="element-114">⚡ FLASH —</span>

                <div className="flex items-center gap-0.5 font-mono" data-id="element-115">
                  <span className="bg-black text-[#14b8a6] px-1 py-px rounded text-xs min-w-[2ch] text-center" data-id="element-116">
                    {pad(minutes)}
                  </span>
                  <span className="text-black font-black animate-pulse text-xs" data-id="element-117">
                    :
                  </span>
                  <span className="bg-black text-[#14b8a6] px-1 py-px rounded text-xs min-w-[2ch] text-center" data-id="element-118">
                    {pad(seconds)}
                  </span>
                </div>

                <span className="hidden sm:inline" data-id="element-119">precio especial</span>

                <button onClick={() => {
            if (typeof window !== 'undefined' && (window as any).fbq) {
              ;
              (window as any).fbq('track', 'AddToCart', {
                content_name: 'Ingresos Digitales Atómicos',
                content_type: 'product',
                value: 6.39,
                currency: 'USD'
              });
            }
            window.open('https://www.simplementemejor.com/cart/51696108929304:1', '_blank');
          }} className="ml-1 bg-black text-[#14b8a6] px-2 py-px rounded text-[10px] font-bold hover:bg-gray-900 transition-colors uppercase tracking-wider" data-id="element-120">
                  Comprar
                </button>
              </>}

            <button onClick={() => setVisible(false)} className="absolute right-2 top-1/2 -translate-y-1/2 text-black/60 hover:text-black transition-colors" aria-label="Cerrar banner" data-id="element-121">
              <X size={12} data-id="element-122" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}